var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AuthConstraint_1;
import React, { Children, Component, Fragment } from 'react';
import { AwesomeComponent, ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { arrayOf, bool, element, list, oneOf, oneOfType, string, tuple } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { AuthenticationService, Logical } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { enumValues, getLostProps, isFunction, propagateProps } from '@philips-internal/oswald-ui-utils';
import { AuthConstraintAPI } from './auth-constraint-api.js';
const AuthConstraintContainer = {
    acceptedTypes: enumValues(ComponentType),
    name: '',
};
let AuthConstraint = AuthConstraint_1 = class AuthConstraint extends Component {
    hasPermission() {
        const { permissions, claims, logical } = this.props;
        if (!AuthenticationService.isAuthenticated()) {
            return false;
        }
        const hasPermissions = AuthenticationService.matchPermissions(permissions, logical);
        const hasClaims = AuthenticationService.matchClaims(claims, logical);
        const fn = {
            [Logical.AND]: () => hasPermissions && hasClaims,
            [Logical.OR]: () => hasPermissions || hasClaims,
        }[logical];
        if (isFunction(fn)) {
            return fn();
        }
        return false;
    }
    render() {
        const { children, uuid, redirect } = this.props;
        const lostProps = getLostProps(AuthConstraint_1.propTypes, this.props);
        if (Children.count(children) === 0) {
            return React.createElement(Container, { acceptedTypes: AuthConstraintContainer.acceptedTypes, className: "u-expand", uuid: uuid });
        }
        const hasPermission = this.hasPermission();
        if (!hasPermission && redirect) {
            AuthenticationService.redirectToLogin();
        }
        if (!hasPermission) {
            return null;
        }
        return (React.createElement(Fragment, null, propagateProps(children, lostProps)));
    }
};
AuthConstraint.propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    claims: tuple([string.placeholder('claim'), string.placeholder('value')]).group('constraint'),
    logical: oneOf(enumValues(Logical)).group('logical'),
    permissions: list.group('constraint'),
    redirect: bool,
    uuid: string,
};
AuthConstraint.defaultProps = {
    claims: {},
    logical: Logical.AND,
    permissions: [],
};
AuthConstraint = AuthConstraint_1 = __decorate([
    AwesomeComponent({ api: AuthConstraintAPI, containers: [AuthConstraintContainer], type: ComponentType.BEHAVIOR })
], AuthConstraint);
export { AuthConstraint, };
//# sourceMappingURL=auth-constraint.js.map